// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.info-panel[data-v-31cb1204] {\n  font-weight: normal;\n  font-size: 16px;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
